import { useTranslation } from "react-i18next";
import { Col, Row } from "antd";
import React from "react";
import { Draft, GroupsExam, QuizProps } from "../../../../types/scoring-course";

interface ScoreByGroupItemProps {
  group: GroupsExam;
  quizzesCompleted?: Draft[];
}

function ScoreByGroupItem({
  group,
  quizzesCompleted = [],
}: ScoreByGroupItemProps) {
  const { t } = useTranslation();
  const name = group?.title;
  console.log(quizzesCompleted);
  
  const points =
    group?.quiz?.reduce((total: number, item: QuizProps) => {
      const currentQuiz = quizzesCompleted?.find(
        (draft: Draft) => draft.quizId === item.id
      );
      return currentQuiz ? total + currentQuiz?.points : total;
    }, 0) || 0;
  return (
    <Row className="pl-4">
      <Col span={12}>
        <span className="secondary-color text-score-wrap">{name}</span>
      </Col>
      <Col span={12}>
        <span className="secondary-color">{points} {t("điểm", "điểm")}</span>
      </Col>
    </Row>
  );
}

export default ScoreByGroupItem;
